<template>
	<div class="tab-content">
		<Form :label-width="80" @submit.native.prevent="preventSubmit" inline>
			<FormItem label="城市名称:">
				<Input v-model="query.cityName"></Input>
			</FormItem>
			<FormItem label="物品名称:">
				<Input v-model="query.goodsName"></Input>
			</FormItem>
			<FormItem label="">
				<Button type="primary" @click="search">查询</Button>
			</FormItem>
			<FormItem label="" :label-width="20">
				<Button type="primary" @click="exportTable" :loading="exportBtn">导出表格</Button>
			</FormItem>
		</Form>
		<Content>
			<Table stripe :columns="columns" :data="washing.data" :loading="washing.loading" :width="1000"></Table>
			<div style="margin: 10px;overflow: hidden">
				<Page show-sizer :page-size="query.pageSize" :total="washing.total" :current="query.page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
			</div>
		</Content>
		<Modal title="修改费用" :loading="true" v-model="modal.display" @on-ok="submitBtn" ref="editModal">
			<Form :label-width="150" label-position="left" :rules="modal.rules" ref="editForm">
				<FormItem label="城市id：">
					<Input type="text" disabled v-model="modal.data.cityId"></Input>
				</FormItem>
				<FormItem label="城市名称：">
					<Input type="text" disabled v-model="modal.data.cityName"></Input>
				</FormItem>
				<FormItem v-for="good in modal.data.goods" :key="good.id" :label="`${good.goodsDesc ? `${good.goodsName}-${good.goodsDesc}` : good.goodsName}：`">
					<Input type="text" v-model="good.price"><span slot="append">元</span></Input>
				</FormItem>
			</Form>
		</Modal>
	</div>
</template>

<script>
import Utils from "@/utils";
import API from "@/api";
import Config from "@/config";
import expandRow from "@/components/table-expand";

export default {
	mounted() {
		this.$Notice.config( {
			top: 200
		} );
	},
	created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
	},
	methods: {
		search() {
			this.query.page = 1
			this.queryConsumablesList()
		},
		changePage( page ) {
			this.query.page = page
			this.queryConsumablesList()
		},
		changePageSize( size ) {
			this.query.page = 1
			this.query.pageSize = size
			this.queryConsumablesList()
		},
		queryConsumablesList() {
			this.$emit( 'onQueryWashingList', this.query )
		},
		async editConsumPrice() {
			const goods = this.modal.data.goods;
			let goodIds = [];
			goods.forEach( good => {
				goodIds.push( {
					goodsId: good.goodsId,
					price: good.price * 100
				} )
			} )
			const resp = ( await API.omsAPI[this.env].cleaner.editWashingPrice(
				encodeURI( this.modal.data.cityId ),
				JSON.stringify( goodIds ),
				this.token
			) ).data;
			this.modal.display = false
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: '修改失败',
					desc: resp.msg
				} )
				return
			}
			this.$Notice.success( {
				title: '保存成功',
				desc: `您已成功保存${ this.modal.data.cityName }的布草洗涤费设置`
			} )
			this.queryConsumablesList()
		},
		submitBtn() {
			let goods = this.modal.data.goods;
			const reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
			for ( let i = 0; i < goods.length; i++ ) {
				if ( !reg.test( goods[i].price ) ) {
					this.$Notice.error( {
						title: '价格格式有误',
						desc: `物品${ goods[i].goodsId }-${ goods[i].goodsName }的价格格式有误`
					} )
					this.$refs.editModal.buttonLoading = false
					return
				}
			}
			this.editConsumPrice()
		},
		exportTable() {
			if ( !Utils.hasPermission( 'excel_MmLinenPrice' ) ) {
				this.$Notice.error( {
					title: "无权限操作"
				} );
				return
			}
			let params = {
				page: 1,
				rows: 9999,
				cityName: this.query.cityName,
				goodsName: this.query.goodsName
			}
			const initParams = params => {
				let paramsStr = '';
				Object.keys( params ).forEach( item => {
					if ( params[item] !== "" ) {
						paramsStr += item + '=' + params[item] + '&'
					}
				} )
				return paramsStr.substring( 0, paramsStr.lastIndexOf( '&' ) );
			}
			let urlParams = initParams( params );
			const url = `${ Config[this.env].analysisUrl }excel/MmLinenPrice?${ urlParams }`;
			// window.open()
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this, "exportBtn" )

		},
		preventSubmit() {
			return false;
		}
	},
	components: {expandRow},
	data() {
		return {
			exportBtn: false,
			cleanerAllGood: [],
			query: {
				page: 1,
				pageSize: 10,
				cityName: '',
				goodsName: ''
			},
			washing: {
				loading: false,
				data: [],
				total: 0
			},
			modal: {
				display: false,
				data: [],
				rules: {
					goods: [[
						{required: true, type: "string", message: '请填写损耗费', trigger: 'blur'},
						{type: "string", pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/, message: '格式有误', trigger: 'change'},
					]]
				}
			},
			columns: [
				{
					type: 'expand',
					width: 50,
					render: ( h, params ) => {
						return h( expandRow, {
							props: {
								row: params.row.goodsList
							},
						} )
					}
				},
				{
					title: '城市id',
					align: 'center',
					width: 200,
					key: 'cityId'
				},
				{
					title: '城市名称',
					align: 'center',
					width: 200,
					key: 'cityName'
				},
				{
					title: '物品名称',
					align: 'center',
					width: 200,
					key: 'goodsName'
				},
				{
					title: '洗涤费',
					align: 'center',
					width: 150,
					key: 'price'
				},
				{
					title: '操作',
					align: 'center',
					width: 200,
					render: ( h, params ) => {
						return h( 'Button', {
							props: {
								type: 'primary',
								size: 'small'
							},
							on: {
								click: () => {
									let goods = JSON.parse( JSON.stringify( params.row.goodsList ) );
									goods.forEach( good => {
										good.price = ( good.price / 100 ).toFixed( 2 );
										good.purchasePrice = ( good.purchasePrice / 100 ).toFixed(
											2
										);
									} );
									this.modal.data = {
										cityId: params.row.cityId,
										cityName: params.row.cityName,
										goods: goods
									}
									this.modal.display = true
								}
							}
						}, '修改费用' )
					}
				},
			]
		}
	},
	props: {
		washingData: Object
	},
	watch: {
		washingData: function ( val ) {
			if ( val.content ) {
				this.washing.data = val.content
				this.washing.total = val.totalCount
			}
		}
	}
}
</script>

<style scoped>
.tab-content {
	padding-left: 10px;
}
</style>





// WEBPACK FOOTER //
// src/pages/cleaner/washing-feeds.vue